import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, eyebrow, children }) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <main
      data-testid="legal-page"
      className="relative min-h-screen pt-28 pb-24 px-6"
    >
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-[#CCFF00] transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        {eyebrow && (
          <span className="text-xs uppercase tracking-[0.2em] text-[#CCFF00] font-semibold">
            {eyebrow}
          </span>
        )}
        <h1 className="font-display mt-3 text-4xl sm:text-5xl font-black tracking-tighter text-white">
          {title}
        </h1>

        <div
          data-testid="legal-content"
          className="mt-10 prose prose-invert max-w-none text-zinc-300 leading-relaxed
            [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-12 [&_h2]:mb-4
            [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-white [&_h3]:mt-8 [&_h3]:mb-3
            [&_p]:my-4 [&_p]:text-zinc-300
            [&_ul]:my-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_li]:text-zinc-300
            [&_a]:text-[#CCFF00] [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-white
            [&_strong]:text-white [&_strong]:font-semibold"
        >
          {children}
        </div>
      </div>
    </main>
  );
}
